import { combineReducers } from 'redux';
import today from './Today';
import current from './Current';
import latest from './Latest';

export default combineReducers({ today, current, latest });
